export const extractStationAndRegionIds = (location: string) => {
  const [stationId, regionId] = location.split("-");

  if (!stationId || !regionId) {
    throw new Error("Location is invalid");
  }

  return [stationId, regionId];
};
